import React from "react";
import StudentForm from "../../components/admin/CreateUser/StudentForm/StudentForm";

function FormSt({ defaultStep }) {
  return <StudentForm defaultStep={defaultStep} />;
}

export default FormSt;
